import { render, staticRenderFns } from "./PublicJaLFormsIndex.vue?vue&type=template&id=6cbc5ad8&scoped=true&"
import script from "./PublicJaLFormsIndex.vue?vue&type=script&lang=js&"
export * from "./PublicJaLFormsIndex.vue?vue&type=script&lang=js&"
import style0 from "./PublicJaLFormsIndex.vue?vue&type=style&index=0&id=6cbc5ad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbc5ad8",
  null
  
)

export default component.exports